import { brandPrimary, charmGray, shuffleGray, white } from '@Styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	primaryTabList: {
		display: 'flex',
		borderBottom: `1px solid ${shuffleGray}`,
		minHeight: 40,
	},
	primaryTabTrigger: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		padding: '16px 16px 8px 16px',
		cursor: 'pointer',
		border: 'none',
		background: 'none',
		color: charmGray,
		fontSize: 14,
		':hover': {
			backgroundColor: '#f7fafc',
		},
		':is([data-disabled])': {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
		':is([data-disabled]):hover': {
			backgroundColor: white,
		},
		':is([data-state="active"])': {
			color: brandPrimary,
			boxShadow: `0 2px 0 ${brandPrimary}`, // covers bottom border without using negative margin
		},
	},
});
